// extracted by mini-css-extract-plugin
module.exports = {"root":"HorizontalLine_root__-_yOF"};